import DonateRow from "../../../../src/components/articles/DonateRow";
import NewsletterRow from "../../../../src/components/newsletter/NewsletterRow";
import MakerOSSection from "../../../../src/components/ads/MakerOSSection";
import FeaturedJobsSection from "../../../../src/components/jobs/FeaturedJobsSection";
import VideoComponent from "../../../../src/components/videos/VideoComponent";
import InlineAffiliateBanner from "../../../../src/tailwindComponents/InlineAffiliateBanner";
import * as React from 'react';
export default {
  DonateRow,
  NewsletterRow,
  MakerOSSection,
  FeaturedJobsSection,
  VideoComponent,
  InlineAffiliateBanner,
  React
};